import React from "react";
import Card from "@mui/joy/Card";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";

// components
import TextField from "./MiniFields/TextField";
import MultiSelect from "./MiniFields/MultiSelect";
import Select from "./MiniFields/Select";
import Boolean from "./MiniFields/Boolean";


const fieldMapping = {
    input: TextField,
    multiselect: MultiSelect,
    select: Select,
    boolean: Boolean,
}


class CommonFilterSidebar extends React.Component {

    processForm(event){
        event.preventDefault();
        let formData = new FormData(event.currentTarget);
        console.log(formData)
    }

    render(){
        return(
            <Card
                sx={{
                    width: '20%'
                }}
            >
                <form
                    onSubmit={this.processForm.bind(this)}
                >
                    {this.props.fields.map((field) => {
                        let fieldClass = fieldMapping[field.type]
                        return(
                            <FormControl>
                                <FormLabel>
                                    {field.label}
                                </FormLabel>
                                <fieldClass
                                    {...field.props}
                                />
                            </FormControl>
                        )
                    }
                    )}
                </form>
            </Card>
        )
    }
}

export default CommonFilterSidebar